module.exports = __webpack_public_path__ + "static/img/logo.82e88a1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.gif
// module id = IS4X
// module chunks = 3